const TIME_ZONE = 'Asia/Almaty'

export default {
    /**
     * Текущая дата по Казахстану в формате YYYY-MM-DD.
     * toISOString() отдаёт дату в UTC: с 00:00 до 05:00 по Алматы это ещё вчерашний день.
     */
    todayIso(now = new Date()) {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: TIME_ZONE,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).formatToParts(now)
        const part = (type) => parts.find(item => item.type === type).value

        return `${part('year')}-${part('month')}-${part('day')}`
    },
    /**
     * Сдвиг даты YYYY-MM-DD на days дней. Считается в UTC, поэтому не зависит от пояса браузера.
     */
    addDays(isoDate, days) {
        const date = new Date(`${isoDate}T00:00:00Z`)
        date.setUTCDate(date.getUTCDate() + days)

        return date.toISOString().split('T')[0]
    },
}
